import { DecimalPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { AnimatedValueComponent } from '../animated-value/animated-value.component';

@Component({
    selector: 'app-stat',
    templateUrl: './stat.component.html',
    styleUrl: './stat.component.css',
    imports: [AnimatedValueComponent, DecimalPipe],
})
export class StatComponent {
    readonly value = input.required<number | null>();
    /** Pre-translated unit after the number, e.g. `/ h`. */
    readonly unit = input<string>();
    /** Pre-translated label under the value. */
    readonly label = input.required<string>();
}
